import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const LS_THEME = "m365matrix.theme";

const readInitial = () => {
  try {
    const saved = window.localStorage.getItem(LS_THEME);
    if (saved === "dark" || saved === "light") return saved;
  } catch {
    /* ignore */
  }
  return "dark"; // dark-first design
};

const ThemeContext = createContext({ theme: "dark", toggle: () => {}, setTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(readInitial);

  useEffect(() => {
    const body = document.body;
    const root = document.documentElement;
    body.classList.remove("theme-dark", "theme-light");
    body.classList.add(theme === "dark" ? "theme-dark" : "theme-light");
    root.classList.toggle("dark", theme === "dark");
    root.style.colorScheme = theme;
    try {
      window.localStorage.setItem(LS_THEME, theme);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === "dark" ? "light" : "dark")), []);
  const value = useMemo(() => ({ theme, toggle, setTheme }), [theme, toggle]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export default function useTheme() {
  return useContext(ThemeContext);
}
